export function getEnvironment(): 'production' | 'staging' | 'development' {
  if (typeof window === 'undefined') {
    return 'development';
  }

  const { hostname } = window.location;
  if (hostname === 'localhost') {
    return 'development';
  }
  if (
    /-staging\./.test(hostname) ||
    /netlify\./.test(hostname) ||
    /\.deploy-preview\./.test(hostname)
  ) {
    return 'staging';
  }

  return 'production';
}
